import { createAction } from "@ngrx/store";
import { SYNC_SUFFIX } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { Credential, RegistrationResponse } from "../registration.model";

import { AamsRegistrationPayload } from "./aams-registration.model";

export const ACTION_PREFIX = "[AAMS Registration]";

export const AAMS_REGISTRATION_ACTION_TYPE = {
	getRegistrationToken__DO_NOT_USE__: `${ACTION_PREFIX} DO NOT USE - Get Registration Token`,
	getRegistrationToken: `${ACTION_PREFIX} Get Registration Token`,
	getRegistrationTokenSuccess: `${ACTION_PREFIX} Get Registration Token Success`,
	getRegistrationTokenFail: `${ACTION_PREFIX} Get Registration Token Fail`,

	setRegistrationDetails: `${ACTION_PREFIX} Set Registration Form Data ${SYNC_SUFFIX}`,
};

export namespace AamsRegistrationAction {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	export const getRegistrationToken__DO_NOT_USE__ = createAction(
		AAMS_REGISTRATION_ACTION_TYPE.getRegistrationToken__DO_NOT_USE__,
		(payload: AamsRegistrationPayload) => ({ payload })
	);

	export const getRegistrationToken = createAction(
		AAMS_REGISTRATION_ACTION_TYPE.getRegistrationToken,
		(payload: AamsRegistrationPayload) => ({ payload })
	);

	export const getRegistrationTokenSuccess = createAction(
		AAMS_REGISTRATION_ACTION_TYPE.getRegistrationTokenSuccess,
		(response: RegistrationResponse, credential?: Credential) => ({
			payload: {
				token: response.token,
				hashedEmail: response.hashedEmail,
				credential,
			},
		})
	);

	export const getRegistrationTokenFail = createAction(
		AAMS_REGISTRATION_ACTION_TYPE.getRegistrationTokenFail,
		(error: AppError) => ({ payload: error })
	);

	export const setRegistrationDetails = createAction(
		AAMS_REGISTRATION_ACTION_TYPE.setRegistrationDetails,
		(registrationDetails: AamsRegistrationPayload, initialStep: number) => ({
			payload: {
				registrationDetails,
				initialStep,
			},
		})
	);
}
